// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".charts-main {\n  font-size: 1.2rem;\n  padding: 1rem;\n}\n.charts-main .ant-page-header {\n  margin-bottom: 1rem;\n}\n.charts-main .ant-table-content {\n  overflow-x: auto;\n}\n", ""]);
// Exports
module.exports = exports;
